define([
	"dojo/_base/declare",
	"SiteAdmin/AttributeMap/MappedAttributeId",
	"./PartMaterialAttributeMapTable"
], function(declare,MappedAttributeId,PartMaterialAttributeMapTable) {

	return declare(MappedAttributeId, {

		sourceClassName: PartMaterialAttributeMapTable.SOURCE_CLASS_NAME,
		destinationClassNames: PartMaterialAttributeMapTable.DEST_CLASS_NAMES,

		sourceAttributeNames: PartMaterialAttributeMapTable.SOURCE_ATTR_NAMES,
		destinationAttributeNames: PartMaterialAttributeMapTable.DEST_ATTR_NAMES

	});
});